import { render } from "./JobReviewTask.vue?vue&type=template&id=11bf7b9b"
import script from "./JobReviewTask.vue?vue&type=script&lang=js"
export * from "./JobReviewTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__